import createTableStore from "ds/components/Table/store/useTableStore";

import { FLOWS_PROJECT_ROLES_COLUMN_CONFIG, FLOWS_PROJECT_ROLES_STORAGE_KEY } from "./constants";

const useFlowsProjectRolesTableStore = createTableStore({
  storageKey: FLOWS_PROJECT_ROLES_STORAGE_KEY,
  config: FLOWS_PROJECT_ROLES_COLUMN_CONFIG,
});

export default useFlowsProjectRolesTableStore;
